import { ColorPicker, ColorPickerProps } from 'antd'
import { FC, useContext } from 'react'
import CalculationPosition from '../../../../types/api/calculation-position'
import Calculation from '../../../../types/api/calculation'
import { CalculationPageCtx } from '../../calculations-page'

interface UiColorPickerProps {
    value?: string
    record: CalculationPosition | Calculation
}

const UiColorPicker: FC<UiColorPickerProps> = ({ value, record }) => {
    const { onUpdateCalculationPositionProperty } = useContext(CalculationPageCtx)

    const onChange: ColorPickerProps['onChange'] = (_, hex) =>
        onUpdateCalculationPositionProperty(record, ['uiColor', hex])

    return (
        <ColorPicker
            value={value || '#ffffff'}
            presets={[
                {
                    label: 'Фирменные',
                    colors: [
                        '#FFB3BA',
                        '#FFDFBA',
                        '#FFFFBA',
                        '#BAFFC9',
                        '#BAE1FF',
                        '#D7BAFF',
                        '#FFC4E1',
                        '#FFD6A5',
                        '#FDFFB6',
                        '#CAFFBF',
                        '#9BF6FF',
                        '#BDB2FF',
                    ],
                },
                {
                    label: 'Убрать цвет',
                    colors: ['#ffffff'],
                },
            ]}
            onChange={onChange}
            size='small'
        />
    )
}

export default UiColorPicker
